/**
 * It defines all the application routes for wtf path and name.
 */
const appRoutes = {
  upload: '/pages/whatthefont',
  crop: '/pages/whatthefont/crop',
  result: '/pages/whatthefont/result',
};

export default appRoutes;



// WEBPACK FOOTER //
// ./src/constants/appRoutes.js